import CaireFont from './CaireFont';
export default CaireFont;
